<template>
  <!-- Fixed Sidebar Left -->

<div class="fixed-sidebar">
	<div class="fixed-sidebar-left sidebar--small" id="sidebar-left">
    <router-link class="logo" :to="{name:'HomeDefaultPage'}">
        <div class="img-wrap">
        <img src="/image/llogo.jpeg" alt="">
      </div>
    </router-link>

	</div>
</div>

<!-- ... end Fixed Sidebar Left -->
</template>

<script>
export default {

}
</script>

<style>

</style>